<script>

import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';

export default {
  name: 'ProductChoiceElement',
  emits: ['additem', 'removeitem'],
  props: {
    choices: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: this.value ? this.value : '*',
    }
  },
  watch: {
    value() {
      this.selected = this.value;
    },
    choices() {
      this.setChoices();
    }
  },
  destroyed: function () {
    this.choicesInstance.destroy();
  },
  methods: {
    handleAddOption(e) {
      let object = {
        group: this.extractGroup(),
        value: e.detail.value
      }
      this.$emit('additem', object);
      this.selected = e.detail.value;
    },
    handleRemoveOption(e) {
      // collapse whitespace
      let object = {
        group: this.extractGroup(),
        value: e.detail.value
      }
      this.$emit('removeitem', object);
    },
    setChoices() {
      if (this.choicesInstance) {
        this.choicesInstance.setChoices(this.choices, 'value', 'label', true);
      }
    },
    resetFilter() {
      if ( this.choicesInstance) {
        this.choicesInstance.setChoiceByValue(this.choices[0].value);
      }
    },
    extractGroup() {

      var title = this.title.replace('(%)', 'Percentage');
      return title.toLowerCase().replace(/[\s]/g, '');
    }
  },
  mounted() {

    this.choicesInstance = new Choices(this.$refs.select, {
      searchEnabled: true,
      itemSelectText: '',
      position: 'bottom',
      removeItemButton: this.title == 'Countries' ? true : false,
      noChoicesText: 'No more choices.',
      shouldSort: false,
      placeholder: this.title == 'Countries' ? true : false,
      placeholderValue: 'All',
      choices: this.choices,
      allowHTML: false
    });

    this.$refs.select.addEventListener('addItem', this.handleAddOption, false);
    this.$refs.select.addEventListener('removeItem', this.handleRemoveOption, false);

    let group =  this.extractGroup();

    if (window.location.search) {

      console.log('there is a search string');
      
      // handle a query string
      let urlParams = new URLSearchParams(window.location.search);
      let value = urlParams.get(group);


      if ( value !== null) {
        let values = value.split(',');
        // for each value in values, set the choice
        setTimeout(() => {
          this.choicesInstance.setChoiceByValue(values);
        }, 1000);
      }

      // clear the session storage filters
      sessionStorage.removeItem('filters');
     
  
    } else if (sessionStorage.filters) {

      let filters = JSON.parse(sessionStorage.filters);
      let val = filters[group];

      this.choicesInstance.setChoiceByValue(val[0]);

    } else {
      // default
      if ( group == 'countries' ) {
        this.choicesInstance.setChoiceByValue('united-states');
      }
    }

  }
}
</script>

<template>
  <label class="choices">{{ title }}</label>
  <div class="select-wrapper" :name="title">
    <select class="form-control" ref="select" :value="selected" :multiple="title == 'Countries'">
    </select>
    <span v-if="this.title != 'Countries' && selected!='*' && selected!='0' && selected!='100'" @click="resetFilter" class="reset-filter"><i class="fa-sharp fa-solid fa-xmark"></i></span>
  </div>
</template>